/**
 * Company Management Layout
 *
 * Dedicated full-screen layout for "Company Mode" — replaces the standard
 * DashboardLayout + StoreManagementLayout when managing a company's stores.
 *
 * Provides:
 * - Dedicated sidebar with company/store navigation
 * - Simplified header with user info and back-to-admin action
 * - StoreManagementContext wrapping all child routes
 */

import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { StoreManagementProvider } from '@/contexts/StoreManagementContext';
import { CompanyManagementSidebar } from './CompanyManagementSidebar';
import { Header } from './Header';

// ============================================================================
// LAYOUT
// ============================================================================

function CompanyManagementInner() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen overflow-hidden">
      <CompanyManagementSidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />

      <div className="flex flex-1 flex-col overflow-hidden">
        <Header onMenuClick={() => setSidebarOpen(true)} />

        <main className="flex-1 overflow-auto bg-muted/30 p-4 lg:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export function CompanyManagementLayout() {
  return (
    <StoreManagementProvider>
      <CompanyManagementInner />
    </StoreManagementProvider>
  );
}

export default CompanyManagementLayout;
